/**
 * Thumbnail items JS controller. Handles the correct height for thumbnail images
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class ThumbnailItems
 */
class ThumbnailItems {


    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // Get the wrappers, images and titles for thumbnail items
        this.thumbnailImageWraps = $( '.js-thumbnail-imagewrap' );
        this.thumbnailImages =  $( '.js-thumbnail-image' );
        this.thumbnailTitles =  $( '.js-thumbnail-title' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Calculate the height for thumbnail items on window resize
        $( window ).on( 'resize', () => {
            this.calculateHeight();
        });
    }

    /**
     * Calculate height for thumbnail items. This is done to allow the image to have
     * the wanted aspect ratio, and to help the title to be positioned underneath that, but
     * to grow upwards in size (its absolute, and in the bottom of the wrap)
     */
    calculateHeight() {


        // Create the smallest height variable
        let smallestHeight = 0;

        // Get the thumbnail with the smallest text height (this would be one line of text)
        this.thumbnailTitles.each( ( index, element ) => {

            // Set the smallest height to be the first items titles height
            if ( index == 0 ) {
                smallestHeight = $( element ).outerHeight();
            };

            // Change the smallest height if its smaller than the current height
            if ( $( element ).outerHeight() < smallestHeight ) {
                smallestHeight = $( element ).outerHeight();
            };

        });

        // Combine the smallest height variable + the image size to get the correct
        // thumbnail wrap size. -1 is there to avoid the 1px gap which might be present at some widths
        const heightForImagewraps = this.thumbnailImages.first().outerHeight() + smallestHeight - 1;

        // Set the correct thumbnail wrap size for thumbnail items with title
        this.thumbnailImageWraps.each( ( index, element ) => {

            // Check if the item has a title
            if ( $( element ).hasClass( 'js-thumbnail-imagewrap-withtitle' )  ) {

                // Set the correct height for items with titles
                $( element ).height( heightForImagewraps );
            }
        });

    }


    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.calculateHeight();

    }
}

// Export the class reference.
module.exports = ThumbnailItems;



// WEBPACK FOOTER //
// ./assets/scripts/thumbnail-items.js